import { numberToPrettyString } from '@cian/utils';

import type { IOffer } from 'shared/offer';

export function getTotalArea(offer: IOffer): string | undefined {
  if (offer.totalArea) {
    return numberToPrettyString(Number(offer.totalArea));
  }

  return undefined;
}
